import { Release } from './types';

/** A non-numeric or missing segment counts as 0, so a malformed version still sorts. */
function versionParts(version: string): number[] {
  return version.split('.').map((part) => {
    const value = Number(part);
    return Number.isFinite(value) ? value : 0;
  });
}

/** Returns a negative number when a is older, a positive number when a is newer, 0 when equal. */
export function compareReleaseVersions(a: string, b: string): number {
  const pa = versionParts(a);
  const pb = versionParts(b);
  const length = Math.max(pa.length, pb.length, 3);
  for (let i = 0; i < length; i += 1) {
    const left = pa[i] ?? 0;
    const right = pb[i] ?? 0;
    if (left !== right) {
      return left - right;
    }
  }
  return 0;
}

export function findRelease(releases: Release[], version: string): Release | undefined {
  return releases.find((release) => release.version === version);
}
